export default [
  {
    position: "absolute",
    top: 1.8,
    left: 0.8,
    class: "tooltips",
    animation: "pulsing",
    isTooltip: true,
    navPos: 7,
    tooltipText: "vacanciesP3.back",
    tooltipClass: "right",
    hover: false,
    id: "HR_Homepage_Navigation_Recruit",
    index: 0,
  },
  {
    position: "absolute",
    top: 2.4,
    left: 17,
    class: "dialog",
    animation: "pulsing",
    modalClass: "modal-top-left",
    isDialog: true,
    isAction: true,
    modal: false,
    mTitle: "candidatePortalP3.uniqueBrandingTitle",
    mBody: "candidatePortalP3.uniqueBrandingBody",
    id: "SP_Homepage_Action_UniqueBranding",
    plusIcon: true,
    index: 1,
  },
  {
    position: "absolute",
    top: 7,
    left: 65,
    class: "video",
    animation: "pulsing",
    modalClass: "modal-top-right",
    isDialog: true,
    modal: false,
    mTitle: "candidatePortalP3.buildYourWayTitle",
    mBody: "candidatePortalP3.buildYourWayBody",
    isVideo: true,
    videoThumb: "HR-Edit-Build-Thumb",
    videoURL: "HR-Edit-Build.mp4",
    vidIcon: true,
    id: "HR_Homepage_Video_PersonalizedHomepage",
    index: 2,
  },
  {
    position: "absolute",
    top: 86,
    left: 79,
    class: "video",
    animation: "pulsing",
    modalClass: "modal-bottom-right",
    isDialog: true,
    modal: false,
    mTitle: "candidatePortalP3.differentiatedTitle",
    mBody: "candidatePortalP3.differentiatedBody",
    isVideo: true,
    videoThumb: "HR-Build-Your-Way-Thumb",
    videoURL: "HR-Build-Your-Way.mp4",
    vidIcon: true,
    id: "HR_Homepage_Video_PersonalizedHomepage",
    index: 3,
  },
];
